import React, { useEffect } from "react";
import { ScrollTrigger } from "../animations/gsap.config";

import ContactHero from "../components/contact/ContactHero";
import ContactInfoGrid from "../components/contact/ContactInfoGrid";
import ContactForm from "../components/contact/ContactForm";
import ContactSection from "../components/home/ContactSection";
import SEO from "../components/SEO";
import { useApp } from "../context/AppContext";

const Contact = () => {
  const { companyinfo } = useApp();
  /* Refresh ScrollTrigger after components mount */
  useEffect(() => {
    const timer = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <SEO
        title="Contact Us | Let's Ignite Change"
        description="Get in touch with our team of experts. Located at Century Executive Tower, Bole Atlas, Addis Ababa. Reach out to collaborate on your next project."
        keywords={[
          "Contact Agora Consulting",
          "Bole Atlas office",
          "Addis Ababa consultant address",
          "Consulting firm phone number",
        ]}
        url="https://agoraconsulting-et.com/contact"
        image={`${companyinfo?.logo}`}
      />
      <main className="bg-white transition-colors duration-500">
        <ContactHero />
        <ContactSection />
      </main>
    </>
  );
};

export default Contact;
